// extracted by mini-css-extract-plugin
export default {"wrapper":"page__wrapper"};